import { Card, CardHeader, Code, Heading } from "@amzn/storm-ui";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";

import { CONTENT_OWNER_TROUBLESHOOTING_WIKI } from "../../../constants/links";
import { FeatureFlagsStore } from "../../../store/featureFlags";
import type { DimensionTemplate } from "../../../types/dimensions";
import { ErrorPromptDetails } from "../../../utils/app.utils";
import { LoadingSpinner } from "../../LoadingSpinner";
import { DimensionTemplateBuilder } from "../../dimensions/DimensionTemplateBuilder";

export interface SettingsCardProps {
    dimensionSections: DimensionTemplate[][];
    loading: boolean;
}

/**
 * @deprecated
 **/
export const SettingsCard: React.FunctionComponent<SettingsCardProps> = ({
    dimensionSections,
    loading,
}) => {
    return (
        <Card>
            <CardHeader>
                <Heading renderAs="h2">Settings</Heading>
                <Code renderAs="code">
                    Publisher Portal{" "}
                    {FeatureFlagsStore.getState().uatPackagedInsights
                        ? " UAT"
                        : ""}
                </Code>
            </CardHeader>
            {loading ? (
                <LoadingSpinner />
            ) : (
                <ErrorBoundary
                    fallbackRender={({ error }) => (
                        <ErrorPromptDetails
                            error={error}
                            title="Dimensions failed to render, please contact deck owner"
                            externalLink={CONTENT_OWNER_TROUBLESHOOTING_WIKI}
                        />
                    )}
                >
                    <DimensionTemplateBuilder
                        dimensionSections={dimensionSections}
                    />
                </ErrorBoundary>
            )}
        </Card>
    );
};
